import { Component, Inject } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PERMISSION_INFO, PERMISSION_LABELS, PermissionInfo } from '../../utils/agency-rbac';

/** Fenêtre « i » d'un droit : liste ce que ce droit permet de faire (contenu : PERMISSION_INFO). */
@Component({
  selector: 'app-permission-info-dialog',
  standalone: true,
  imports: [NgIf, NgFor, MatDialogModule],
  template: `
    <div class="pid">
      <div class="pid-head">
        <h2 class="pid-title">{{ label }}</h2>
        <button type="button" class="pid-close" aria-label="Fermer" mat-dialog-close>&times;</button>
      </div>
      <ng-container *ngIf="info; else noInfo">
        <p class="pid-summary">{{ info.summary }}</p>
        <div class="pid-section">Ce que ce droit permet</div>
        <ul class="pid-list">
          <li *ngFor="let item of info.allows">{{ item }}</li>
        </ul>
        <ng-container *ngIf="info.notes?.length">
          <div class="pid-section">À savoir</div>
          <ul class="pid-list pid-notes">
            <li *ngFor="let note of info.notes">{{ note }}</li>
          </ul>
        </ng-container>
      </ng-container>
      <ng-template #noInfo>
        <p class="pid-summary">Aucune description disponible pour ce droit.</p>
      </ng-template>
      <div class="pid-actions">
        <button type="button" class="pid-btn" mat-dialog-close>Fermer</button>
      </div>
    </div>
  `,
  styles: [`
    .pid { padding: 20px 24px; max-width: 560px; font-size: 13px; line-height: 1.45; color: #1f2937; }
    .pid-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
    .pid-title { margin: 0 0 6px; font-size: 17px; font-weight: 600; }
    .pid-close { border: none; background: none; font-size: 24px; line-height: 1; cursor: pointer; color: #6b7280; padding: 0 4px; }
    .pid-summary { margin: 0 0 12px; color: #374151; }
    .pid-section { font-size: 12px; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: .03em; margin: 12px 0 4px; }
    .pid-list { margin: 0; padding-left: 18px; }
    .pid-list li { margin-bottom: 4px; }
    .pid-notes { color: #4b5563; }
    .pid-actions { display: flex; justify-content: flex-end; margin-top: 16px; }
    .pid-btn { border: none; border-radius: 4px; background: #0b3954; color: #fff; padding: 8px 18px; cursor: pointer; font-size: 13px; }
  `],
})
export class PermissionInfoDialogComponent {
  readonly label: string;
  readonly info: PermissionInfo | undefined;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { permission: string }) {
    this.label = PERMISSION_LABELS[data.permission] ?? data.permission;
    this.info = PERMISSION_INFO[data.permission];
  }
}
